
export default {
  name: 'seals-list',

  props: {
    canShowRa1000: {
      required: false,
      type: Boolean
    },
    canShowTrustpilot: {
      required: false,
      type: Boolean
    },
    canShowBestPrice: {
      required: false,
      type: Boolean
    },
    canShowDigicert: {
      required: false,
      type: Boolean
    },
    canShowBCorporation: {
      required: false,
      type: Boolean
    },
    canShowAmvo: {
      required: false,
      type: Boolean
    },
    isBrazilianHomePage: {
      required: false,
      type: Boolean
    }
  },
  computed: {
    getImageLocale() {
      return this.$store.getters.getLocale.split('-')[0]
    }
  },
  methods: {
    getDigicertURL() {
      return `//seal.digicert.com/seals/popup/?tag=eoQLnvG2&url=${process.env.BASE_URL}&lang=${this.$i18n.locale}&cbr=${(new Date()).getTime()}`
    },

    getAmvoURL() {
      return '//www.amvo.org.mx/miembro/Rentcars'
    }
  }
}
